module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/60e316b9b072e587bd2d17999d5e12d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/gold-certificate.png
// module id = emqf
// module chunks = 1